import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'
import { SVGIconProps } from 'commonTypes'

const CompoundsIcon: React.FC<SVGIconProps> = ({ fill, ...props }) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <title>Compounds</title>
            <g
                id="REPORT"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                opacity="0.5"
            >
                <g
                    id="03_Webreport-v3-closed"
                    transform="translate(-10.000000, -230.000000)"
                >
                    <g id="Group-57" transform="translate(0.000000, 99.000000)">
                        <g
                            id="Elements-/-Menu-/-Mainmenu-Copy-12"
                            transform="translate(0.000000, 120.000000)"
                        >
                            <g
                                id="Icons-/-Report"
                                transform="translate(6.000000, 7.000000)"
                            >
                                <g
                                    id="Elements-/-Section-opener-/-Blue"
                                    transform="translate(-11.000000, -5.500000)"
                                >
                                    <rect
                                        id="Rectangle-8"
                                        x="0"
                                        y="0"
                                        width="35"
                                        height="35"
                                    ></rect>
                                </g>
                                <path
                                    d="M18.7086431,11.5286365 C18.0501553,10.8701486 16.9726591,10.8701486 16.3141559,11.5286365 C16.1585181,11.6842743 16.0387861,11.8638647 15.9549752,12.0554237 L12.4591005,11.2532666 L12.4591005,11.1694588 C12.4591005,10.7743722 12.3274029,10.42716 12.0999197,10.1398216 L14.4824537,7.8291605 C14.7697921,8.03268809 15.1169889,8.16438872 15.4881383,8.16438872 C16.421996,8.16438872 17.1882625,7.4101214 17.1882625,6.488171 C17.1882625,5.56622061 16.4339952,4.8 15.5000916,4.8 C14.5661879,4.8 13.7999673,5.55426732 13.7999673,6.47621772 C13.7999673,6.81144594 13.8957468,7.11075302 14.0633686,7.37415428 L11.6330215,9.73278172 C11.3816042,9.57714388 11.0822818,9.49333299 10.7590375,9.49333299 C10.3878882,9.49333299 10.05266,9.61305736 9.77730544,9.80460868 L7.16735269,7.49394761 C7.38284888,7.20660913 7.51454951,6.85941231 7.51454951,6.47629434 C7.51454951,5.54243664 6.7602822,4.80007662 5.81442527,4.80007662 C4.86856834,4.80007662 4.11430104,5.55434395 4.11430104,6.47629434 C4.11430104,7.39824474 4.86856834,8.15251206 5.81442527,8.15251206 C6.13768488,8.15251206 6.44896055,8.05673257 6.71236181,7.90109473 L9.35832765,10.2356624 C9.17873728,10.4990636 9.07098918,10.8223079 9.07098918,11.1575361 C9.07098918,11.504733 9.17874034,11.816024 9.34635904,12.0794099 L6.71234648,14.6535029 C6.44894523,14.497865 6.14963816,14.4020856 5.81440995,14.4020856 C4.86858367,14.4020856 4.11428571,15.1563529 4.11428571,16.0902566 C4.11428571,17.0241602 4.86855302,17.7664743 5.81440995,17.7664743 C6.74826762,17.7664743 7.51453418,17.012207 7.51453418,16.0902566 C7.51453418,15.7071386 7.38283662,15.3599418 7.16733737,15.0845719 L9.77729012,12.546492 C10.05266,12.738051 10.3878882,12.8577677 10.7590222,12.8577677 L11.6210376,16.748867 C11.106219,17.0362055 10.7590222,17.5869452 10.7590222,18.2094966 C10.7590222,19.1433543 11.5132895,19.8857143 12.4591464,19.8857143 C13.3930041,19.8857143 14.1592707,19.131447 14.1592707,18.2094966 C14.1592707,17.2875462 13.4050034,16.5332788 12.4591464,16.5332788 C12.3753386,16.5332788 12.2915247,16.5452513 12.2077291,16.5572237 L11.3696509,12.7619039 C11.78869,12.6062661 12.1358868,12.2830065 12.3154772,11.8759513 L15.8113519,12.6781083 C15.7993795,13.1330686 15.9550212,13.5880135 16.302218,13.9352103 C16.9607058,14.5936982 18.038202,14.5936982 18.6967052,13.9352103 C19.3671616,13.2527853 19.3671616,12.1872729 18.7086776,11.5287698 L18.7086431,11.5286365 Z"
                                    id="Shape"
                                    fill={fill ?? '#09293E'}
                                    fillRule="nonzero"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export default CompoundsIcon
